import Whatsapp from "@/components/floating-buttons/Whatsapp";

const config = {
  whatsapp: Whatsapp
};

export default {
  get: id => config[id]
};